export default {
  name: 'AddNewElementButton',
  props: {
    icon: {
      type: String,
      default: 'fa fa-plus',
    },
    buttonText: {
      type: String,
      require: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledReason: {
      type: String,
      default: null,
    },
  },
};
